import ViewItemTransfer from "../../../../components/@documents/item_transfers/ViewItemTransfer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransferViewPage() {

    return (
        <ViewItemTransfer 
            routeType={routeTypes.workstation}
        />
    )
}